import React, {Fragment} from 'react';

import {ButtonRaw} from '@/components/Button';
import RemoteIconV2 from '@/components/Icon/RemoteIconV2';
import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import {twx} from '@/utils/tailwindUtils';

const DcxTopBannerLoyaltyButtonsBar = ({buttons, className}) => {
    return (
        <div
            className={twx(
                'flex w-full items-center justify-center gap-4 bg-romance px-4 pb-8 md:rounded-xl md:px-8 md:py-4',
                className
            )}
        >
            {buttons.map((icon, index) => {
                const {title, action, amplitudeTrackingValue, alt} = icon;
                const isLast = index === buttons.length - 1;

                return (
                    <Fragment key={index}>
                        <LoyaltyButton
                            title={title}
                            icon={icon}
                            action={action}
                            trackingValue={amplitudeTrackingValue}
                            aria-label={alt}
                        />
                        {!isLast && <div className='h-12 w-0.5 shrink-0 rounded-full bg-primary-dark-65 md:hidden' />}
                    </Fragment>
                );
            })}
        </div>
    );
};

const LoyaltyButton = ({title, icon, action, trackingValue, ariaLabel, ...rest}) => {
    const {redirectToExternalLink} = useConfigExternalLink(action);

    const onButtonClick = () => {
        if (!action) return;

        // TODO: Add tracking
        // amplitudeHomePageTracking.trackLoyaltyButtonsBarClick(trackingValue);
        // googleAnalyticsService.trackLoyaltyButtonClick(trackingValue);
        redirectToExternalLink();
    };

    return (
        <ButtonRaw
            className='flex w-full min-w-24 flex-col items-center justify-start gap-2 p-0 md:flex-row md:justify-center md:px-4'
            onClick={onButtonClick}
            {...rest}
        >
            <div className='h-12 w-12 md:h-16 md:w-16'>
                <RemoteIconV2 className='h-full object-contain' icon={icon} />
            </div>
            <span className='truncate text-center text-16 font-normal text-primary-dark'>{title}</span>
        </ButtonRaw>
    );
};

export default DcxTopBannerLoyaltyButtonsBar;
